var exports = {
  "kv": "checkbox__Ojo58m",
  "DB": "itemContainer__dE65BZ",
  "VR": "responsiveSingleSelectLabel__nOrxof",
  "az": "Box__3UcQNd",
  "wy": "Box_1__YB4hsr",
  "m4": "Octicon__GcDStf",
  "pv": "Box_2___2JTvx",
};

module.exports = exports;
